import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { Button, Card, Form, notification, Tabs } from "antd";
import _ from "lodash";

import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL } from "../../../../request";
import { connect } from "react-redux";

const TabPane = Tabs.TabPane;
// following variables needed for update country
let docLoaded = null;
let restrictedUniversityId = null;

@Form.create()
class AddRestrictedUniversity extends PureComponent {
  callback = (key) => {
    let inputTypes = this.state.inputTypes;

    if (restrictedUniversityId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
      inputTypes[key - 1].opened = true;
      let tempObj = {};
      _.each(inputTypes[key - 1].fields, (v, k) => {
        tempObj[v.key] = docLoaded[v.key];
      });

      setTimeout(() => {
        this.props.form.setFieldsValue(tempObj);
      }, 10);
    }
  };

  handleSubmit = (e) => {
    const { dispatch, form, afterSave } = this.props;

    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        if (restrictedUniversityId) {
          values = { ...values, _id: restrictedUniversityId };

          dispatch(showLoader());

          let x = await Request.updateRestrictedUniversity(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        } else {
          dispatch(showLoader());

          let x = await Request.addRestrictedUniversity(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });

            if (afterSave) {
              afterSave();
            }
            form.resetFields();
            // dispatch('/all-countries')
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        }
      }
    });
  };
  constructor(props) {
    super(props);
    this.state = {
      showSave: 1,
      showFiles: 0,
      refreshChild: false,
      inputTypes: [
        {
          tabTitle: "Basic Details",
          fields: [
            {
              label: "Local University Name",
              key: "universityName",
              required: true,
            },
            {
              label: "Select Country ",
              key: "countryId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  countryId: v,
                  stateId: null,
                  cityId: null,
                });
                this.loadStates(v);
              },
            },
            {
              label: "Select State",
              key: "stateId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  stateId: v,
                  cityId: null,
                });
                this.loadCities(v);
              },
            },
            {
              label: "Select City",
              key: "cityId",
              required: true,
              showSearch: true,
              type: "select",
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  cityId: v,
                });
              },
            }
          ],
        }
      ]
    };
    this.loadCountries();
  }

  setFormValues = async (restrictedUniversityId) => {
    try {
      let { doc } = await Request.getRestrictedUniversity(restrictedUniversityId);

      if (doc) {
        docLoaded = doc;
        this.loadStates(docLoaded.countryId);
        this.loadCities(docLoaded.stateId);

        let tempObj = {};

        let inputTypes = this.state.inputTypes;

        _.each(inputTypes, (val, kk) => {
          if (kk === "0") {
            _.each(inputTypes[0].fields, (v, k) => {
              tempObj[v.key] = docLoaded[v.key];
            });
          }
        });
        this.props.form.setFieldsValue(tempObj);
      }
    } catch (e) {
      console.log(e);
    }
  };

  loadCountries = () => {
    let params = {
      results: 200,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.countryName });
          return temp;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][1].options = resp.data;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadStates = (id) => {
    Request.loadStates(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.stateName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][2].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {});
  };

  loadCities = (id) => {
    Request.loadCities(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.cityName,
          });
          return total;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][3].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {});
  };

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };

  componentDidMount() {
    let searchParams = new URLSearchParams(this.props.search);
    restrictedUniversityId = searchParams.get("_id");

    if (restrictedUniversityId) {
      this.setState({ showFiles: 1 });
      this.setFormValues(restrictedUniversityId);
    }
  }

  render() {
    const {
      formOnly,
      form: { getFieldDecorator },
    } = this.props;

    let form = (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
        <Card bordered={true}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginBottom: 10 }}
            loading={this.props.loading}
          >
            SAVE
          </Button>
          <Tabs onChange={this.callback} type="card">
            {this.state.inputTypes.map((itype, key) => {
              return (
                <TabPane tab={itype.tabTitle} key={key + 1}>
                  <GetAllFormFields
                    apiurl={API_URL}
                    inputSchema={this.state.inputTypes[key]}
                    refresh={this.refreshFxn}
                    getFieldDecorator={getFieldDecorator}
                  />
                </TabPane>
              );
            })}
          </Tabs>
        </Card>
      </Form>
    );

    return (
      <React.Fragment>
        {!formOnly ? (
          <PageHeaderWrapper title={"Add New Restricted University"}>{form}</PageHeaderWrapper>
        ) : (
          form
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddRestrictedUniversity);
